export const SUPPORT_EMAIL = "support@a.team";
export const HELP_EMAIL = "help@a.team";
export const TEAM_FORMATION_AI_EMAIL = "ai@a.team";
